import { render, staticRenderFns } from "./insert-response-template.vue?vue&type=template&id=4cfd3859&"
import script from "./insert-response-template.vue?vue&type=script&lang=js&"
export * from "./insert-response-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports